.trigger,
.close {
  border: 1px solid var(--edge);
  border-radius: 0.25rem;
  background: var(--surface-raised);
  color: var(--ink-secondary);
  font: inherit;
  padding: 0.3em 0.55em;
  cursor: pointer;
}
.dialog {
  position: fixed;
  z-index: 20;
  inset: 0;
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
  padding: var(--gap);
  background: var(--surface);
  color: var(--ink-secondary);
  font-size: clamp(0.8rem, 1vw, 1.15rem);
}
.dialogHeader {
  display: flex;
  align-items: start;
  justify-content: space-between;
  gap: 1rem;
  border-bottom: 1px solid var(--edge);
  padding-bottom: var(--gap);
}
.dialogHeader h2,
.dialogHeader p,
.note,
.empty {
  margin: 0;
}
.dialogHeader h2 {
  color: var(--ink-primary);
  font-size: 1.35em;
}
.dialogHeader p {
  margin-top: 0.2rem;
}
.body {
  min-height: 0;
  overflow: auto;
  padding-top: var(--gap);
}
.legend,
.note,
.empty {
  color: var(--ink-muted);
}
.legend {
  display: block;
  font-size: 0.9em;
}
.axis {
  display: flex;
  justify-content: space-between;
  margin: 0.45rem 0 0.15rem max(10rem, 28%);
  color: var(--ink-muted);
  font-size: 0.85em;
}
.lanes {
  display: grid;
  gap: 0.2rem;
}
.lane {
  display: grid;
  grid-template-columns: minmax(9rem, 28%) minmax(0, 1fr);
  gap: 0.55rem;
  align-items: center;
  min-width: 0;
}
.laneLabel {
  overflow-wrap: anywhere;
}
.track {
  position: relative;
  display: block;
  min-width: 0;
  height: 0.8rem;
  border-bottom: 1px solid var(--edge);
}
.observed,
.expected {
  position: absolute;
  top: 0.1rem;
  width: 0.55rem;
  height: 0.55rem;
  transform: translateX(-50%);
}
.observed {
  border-radius: 50%;
  background: var(--ink-primary);
}
.expected {
  border: 1px solid var(--ink-secondary);
  transform: translateX(-50%) rotate(45deg);
}
.note {
  margin-top: 0.8rem;
  font-size: 0.9em;
}
@media (max-width: 40rem) {
  .axis {
    margin-left: 0;
  }
  .lane {
    grid-template-columns: 1fr;
  }
  .legend {
    justify-self: start;
  }
}
